"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleWithIcon = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CircleWithIcon = exports.CircleWithIcon = function CircleWithIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "white" : _ref$color,
    icon = _ref.icon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: size,
      height: size,
      backgroundColor: color,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0
    }
  }, icon);
};